import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export const cardGridViewStyles: () => Record<string, string> = makeStyles((theme: Theme) => ({
}));